import React from 'react'
import { RouteComponentProps } from 'react-router'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { path } from 'ramda'
import { DefaultButtonBar } from '@/components/button-bar'
import { Button } from '@/components/button'
import { showStopPadPaymentsModal } from '@/features/Pad/modals'
import PaymentSummary from './payment-summary'
import AccountInfo from './account-info'
import PadAgreement from './pad-agreement'
import PaymentStatus from './payment-status'
import PaymentRecurring from './payment-recurring'
import { PaymentData } from '../types'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
`

interface TenantPadPaymentDetailsProps extends RouteComponentProps {
  paymentData: PaymentData
  listingId: string
}

const TenantPadPaymentDetails: React.FC<TenantPadPaymentDetailsProps> = ({
  paymentData,
  listingId,
  history
}) => {
  const { t } = useTranslation()

  const contractId = useSelector(
    path(['listing', listingId, 'contract', 'listing_contract_id'])
  ) as String

  const listingAddress = useSelector(path(['listing', listingId, 'contract', 'address'])) as String
  const isRecurring = paymentData.payment_status === 'upcoming'

  const handleSubmit = () => history.replace(`/rental/${listingId}/payments`)

  const {
    financial_institution_name: instituteName,
    account_number: accountNumber,
    account_type: accountType
  } = paymentData?.payment_method?.financial_info ?? {}

  const handleStopPad = () => {
    showStopPadPaymentsModal({
      listingAddress,
      contractId: contractId,
      submitAction: handleSubmit
    })
  }

  return (
    <>
      <Wrapper>
        <PaymentStatus paymentData={paymentData} />
        {isRecurring ? (
          <PaymentRecurring paymentData={paymentData} listingId={listingId} />
        ) : (
          <PaymentSummary paymentData={paymentData} listingId={listingId} />
        )}
        <AccountInfo
          financialInstitutionName={instituteName}
          accountType={accountType}
          accountNumber={accountNumber}
        />
        <PadAgreement paymentRequestId={paymentData?.id} />
      </Wrapper>
      <DefaultButtonBar>
        {paymentData?.state_machine_cycle === 'pending' && (
          <Button theme="delete" size="small" onClick={handleStopPad}>
            {t('b.payment.view.stop_pad.button', 'Stop PAD')}
          </Button>
        )}
      </DefaultButtonBar>
    </>
  )
}

export default TenantPadPaymentDetails
